import privileges from '@ubeya/shared-web/privileges';
import { ACCOUNT_BILLING_STATUS_MAP } from '@ubeya/shared/constants';

// Admin IDs allowed to access AI Agent
// paul, Nikki, Ryan, Angela Adams (ARC), Lizzie Wright (ARC), Courtney Wakes (ARC), Yuval Avrami, Anna Bradely, Emily Mortimore
export const ALLOWED_AI_AGENT_ADMIN_IDS = [198, 15096, 7621, 22256, 21278, 820, 31967, 5565, 7714, 35451, 32295];

// Account IDs allowed to access AI Agent (all admins in these accounts)
export const ALLOWED_AI_AGENT_ACCOUNT_IDS = [179];

export const getCanAccessAiAgent = ({ isUbeyaAdmin, adminId, accountId, adminPrivileges, billingStatus }) => {
  const isAllowedAdmin = ALLOWED_AI_AGENT_ADMIN_IDS.includes(adminId);
  const isAllowedAccount = ALLOWED_AI_AGENT_ACCOUNT_IDS.includes(accountId);
  const isPayingAccountAdmin =
    [ACCOUNT_BILLING_STATUS_MAP.PAYING, ACCOUNT_BILLING_STATUS_MAP.INTERNAL].includes(billingStatus) &&
    !!adminPrivileges[privileges.REPORTS];
  return isUbeyaAdmin || isAllowedAdmin || isAllowedAccount || isPayingAccountAdmin;
};
